import styled from 'styled-components';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers, mediaQuery } = baseVariables;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  &.container {
    padding-block: ${spacers?.spacers?.[4]};

    @media ${mediaQuery.md} {
      padding-block: ${spacers?.spacers?.[5]};
    }
  }
`;
